import React from 'react';
import { Switch } from '@headlessui/react';

export const Toggle = ({ label, checked, onChange, disabled }) => {
  return (
    <div className="flex items-center justify-between py-2">
      <span className="text-xs font-medium text-gray-700 mr-2">{label}</span>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${
          checked ? 'bg-blue-500' : 'bg-gray-300'
        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </Switch>
    </div>
  );
};
